import emailjs from '@emailjs/browser';

const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const templateIdRegistration = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_REGISTRATION;
const templateIdNonActive = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_NON_ACTIVE;

export const sendRegistrationEmail = async (formData) => {
  const { email, fullName, memberId } = formData;

  const templateParams = {
    email: email,
    memberId: memberId,
    name: fullName,
  };

  try {
    const result = await emailjs.send(
      serviceId,
      templateIdRegistration,
      templateParams,
      publicKey
    );
    console.log('Email sent successfully:', result.text);
    return result;
  } catch (error) {
    console.error('Failed to send email:', error);
    throw error;
  }
};

export const sendNonActiveEmail = async (formData, reason, nonActive) => {
  const { email, fullName } = formData;

  const templateParams = {
    email: email,
    name: fullName,
    reason: reason,
    non_active: nonActive,
  };

  try {
    const result = await emailjs.send(
      serviceId,
      templateIdNonActive,
      templateParams,
      publicKey
    );
    console.log('Email sent successfully:', result.text);
    return result;
  } catch (error) {
    console.error('Failed to send email:', error);
    throw error;
  }
};